import React from 'react';
import { Route } from 'react-router-dom';
import Ec2Management from './Ec2Management';
import ServerManagement from './ServerManagement';

export default class ServerPage extends React.Component {
  render() {
    return (
      <>
        <Route path={'/server/genwizard2'} component={Ec2Management} />
        <Route path={'/server/genwizard4'} component={ServerManagement} />
      </>
    );
  }
}
